import { Component, OnInit ,ViewChild, ChangeDetectorRef, TemplateRef} from '@angular/core';


import { HttpService } from '../http.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';
import { Subject, Subscription, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, mergeMap, map } from 'rxjs/operators';
import { TimeService } from '../time.service';
import { EventService } from '../event.service';


import * as moment from 'moment';
import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { SnackbarService } from '../snackbar.service';
import { SocketService } from '../socket.service';
import { MessagingService } from '../messaging.service';
import { DateTime } from 'luxon';
import { ValidationService } from '../validation.service';
import { MatTable, MatTableDataSource, MatPaginator, MatSort, MatDialog, PageEvent, Sort } from '@angular/material';
import { BidDetailsModalComponent } from './bid-details-modal/bid-details-modal.component';

import { Messages } from '../constants/messages';
import { OrderDetailsComponent } from '../order-details/order-details.component';
import { TranslateService } from '@ngx-translate/core';




export interface Bid {
  order: string;
  auto: boolean;
  amount: number;
  floor_amount?: number;
  decrement_amount?: number;
}

export interface Orders {
  _id: string;
  OIN: string;
  pickDate: string;
  from: Array<any>;
  dropDate: string;
  to: Array<any>;
  requested: string;
  accepted: string;
  vehicle: object;
  // organization: object;
  shipper: object;
  costPerVehicle: string;
  // materials: Array<any>;
  // allocation: string;
  status: string;
  // totalShipments: number;
}

@Component({
  selector: 'app-open-bids',
  templateUrl: './open-bids.component.html',
  styleUrls: ['./open-bids.component.scss']
})
export class OpenBidsComponent implements OnInit {

  currency = 'Rs';
  ordersDisplay = ['order', 'shipper', 'from', 'to', 'vehicle', 'req_no_of_vehicles', 'deadline', 'costPerVehicle', 'action'];
  ordersArray: any = [];
  totalOrders = 0;
  orders: any = [];
  selectedOrderData: any;
  selectedOrderAllLocationsData: any;
  showOrderDetailsView = 0;
  currencySymbol;
  carrierId: Subscription;
  showLoader = false;

  // Filters
  filterOrder = '';
  filterShipper = '';
  dashboardFilters = {
    oin: '',
    shipper_name: '',
    limit: 0,
    skip: 0
  };

  isMobileView = false;

  ordersList: MatTableDataSource<Orders>;
  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  searchTextChanged = new Subject<object>();
  subscription: Subscription;

  messages = new Messages();
  helpData = [
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
    { head: 'Head', data: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry' },
  ];
  constructor(private dialog: MatDialog, private translation:TranslateService,private changeDetection: ChangeDetectorRef, private http: HttpService,
              private storage: StorageService, private route: Router, private events: EventService,
              private timeService: TimeService, private snackbar: SnackbarService, private socket: SocketService,
              private fcmService: MessagingService, private valid: ValidationService) {
    const access_token = this.storage.getFromCookie('access_token');
    if (!access_token) {
      this.route.navigateByUrl('login');
    }
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

  ngOnInit() {
    //new bid order arrives
    this.events.BidOrderArrived().subscribe(
      (response)=>{
        this.getOrders();
      }
    )

    //new bid arrives
    this.events.bidUpdateChanges().subscribe(
      (response) => {
      this.getOrders({});
    })

    //bid order is expired or stopped
    this.events.BidOrderStopped().subscribe(
      (response)=>{
        this.getOrders();
      }
    )
    this.getOrders({});

    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getOrders({});
        const rupee = JSON.parse(localStorage.getItem('carriers'));
        this.currencySymbol = rupee[0].country.currency.symbol;
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );

    this.isMobileView = window.innerWidth <= 480;

    window.addEventListener('resize', () => {
      this.isMobileView = window.innerWidth <= 480;
    });
  }


  getOrders(filter: any = {}) {
    this.showLoader = true;
    filter.limit =  this.paginator.pageSize || 25;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);

    this.http.get('orders/open', filter ).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.ordersArray = data.data.orders;
          this.totalOrders = data.data.count;
          this.orders = [];
          this.ordersArray.forEach((element, i) => {
            const temp: any = {};
            temp._id = element._id;
            temp.accepted = element.accepted;
            temp.rejected = element.rejected;
            temp.deadline = (element.bidding_end_date) ? this.timeService.toShortDateTime(element.bidding_end_date) : '--';
            temp.readableDeadline = (element.bidding_end_date) ? moment(element.bidding_end_date).fromNow() : 'N/A';
            temp.shipper = element.shipper;
            temp.order = element.OIN;
            temp.is_bidding = element.is_bidding;
            temp.lowest_bid_amount = element.lowest_bid_amount;
            temp.pickDate = this.timeService.toShortDate(element.pickup_locations[0].date_time);
            temp.from = element.pickup_locations;
            temp.dropDate = this.timeService.toShortDate(element.delivery_locations[0].date_time);
            temp.to = element.delivery_locations;
            temp.vehicle = element.vehicle_type ? element.vehicle_type : 'N/A';
            temp.bid_flow = element.bidding_flow;
            temp.req_no_of_vehicles = element.req_no_of_vehicles;
            temp.cancelled_vehicles = element.cancelled_vehicles;
            temp.vendor_groups = element.vendor_groups;
            temp.cancelled = element.cancelled;
            temp.min_bid_diff = element.min_bid_diff; //minimum decrement amount during auto bid
            temp.costPerVehicle = element.start_bid_amount;
            temp.created_at = element.created_at;
            temp.status = element.status;
            temp.purchase_order = element.purchase_order || "--";
            temp.segmentation = element.segmentation || "--";
            if(element.payment_term){
              temp.payment_term = element.payment_term;
            }
            temp.docs = (element.doc_urls && element.doc_urls.length) ? element.doc_urls.map(element => {
              return {
                extension: element.substr(element.lastIndexOf('.')).substr(1),
                link: element
              };
            }) : [];
            if(element.weight_based){
              temp.weight_based = element.weight_based;
              temp.uom = element.uom;
            }
            temp.accessories = element.accessories;
            temp.permits = element.permits;
            temp.materials = element.materials;
            temp.shipmentWeight = element.per_vehicle_weight;
            temp.bidding = element.is_bidding ? 'Yes' : 'No';
            temp.comments = element.comments ? element.comments : '--';
            temp.packages = element.no_of_packages ? element.no_of_packages : '--';
            temp.cbm = element.cbm_value ? element.cbm_value : '--';
            this.orders.push(temp);
          });
          this.showLoader = false;

          if (!this.ordersList) {
            this.ordersList = new MatTableDataSource(this.orders);
            this.ordersList.sort = this.sort;
            this.ordersList.paginator = this.paginator;
            this.paginator._intl.itemsPerPageLabel= this.translation.instant('BIDORDER.pagination_label');
          } else {
            this.ordersList = new MatTableDataSource(this.orders);
            this.paginator._intl.itemsPerPageLabel= this.translation.instant('BIDORDER.pagination_label');
          }
        }
      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message,'', 'err');
        this.paginator._intl.itemsPerPageLabel= this.translation.instant('BIDORDER.pagination_label');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  sortOrderData(event){}
  searchFilter(filter,type){}

  pageNavigate(event: PageEvent) {
    this.dashboardFilters.limit = event.pageSize;
    this.dashboardFilters.skip = event.pageIndex * event.pageSize;
    this.getOrders(this.dashboardFilters);
  }

  openBidAcceptDialog(data){
      const dialogRef = this.dialog.open(BidDetailsModalComponent, {
        data:data,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.statusCode == 200 || result && result.code == 412) {
        
          this.getOrders();
        }
      });
  }

  openOrderDetails(element) {
    const dialogRef = this.dialog.open(OrderDetailsComponent, {
      data: element
    });
  }
}
